import store from "@/extensions/store"
// import { useCookies } from "vue3-cookies";

// const { cookies } = useCookies()
export const checkToken = async (token) => {
	token = token ?? null
	if (token === null) {
		if (store.state.admin.token !== null) {
			token = store.state.admin.token
		} else {
			return false
		}
	}

	try {
		const response = await fetch(`${store.state.backend}/users/checktoken`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ "token": token })
		})
		if (response.ok) {
			const data = await response.json()
			store.state.admin.login = data.user.login ?? null
			store.state.admin.token = data.user.token ?? null
			store.state.admin.verified = Boolean(data.user.verified) ?? false
			return true
		} else {
			store.state.admin.token = null
			store.state.admin.username = null
			store.state.admin.verified = false
			// cookies.set("token", null)
			return false
		}
	} catch {
		return false
	}
}

export const checkVerified = async () => {
	if (store.state.admin.token === null && store.state.admin.verified === false) {
		return null
	} else {
		return Boolean(store.state.admin.verified)
	}
}